<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :seq-config="{}"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.dictStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.dictStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            v-if="!disabled"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  params: { techCuttingGoodsCode: row.techCuttingGoodsCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            v-if="!disabled"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.techCuttingGoodsCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
export default {
  mixins: [],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    loading: {
      default: false,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  data() {
    return {
      treeConfig: {},
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: [
        {
          field: 'seq',
          width: 60,
          align: 'center',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          width: 90,
          slots: {
            default: 'opt',
          },
        },
        {
          title: '规格编号',
          field: 'orderGoodsSpecNo',
          headerAlign: 'center',
          align: 'center',
          width: 160,
          showHeaderOverflow: true,
        },
        // {
        //   title: '识别编号',
        //   field: 'identifyGoodsSpecNo',
        //   headerAlign: 'center',
        //   align: 'left',
        //   minWidth: 150,
        //   showHeaderOverflow: true,
        // },
        {
          title: '识别名称',
          field: 'identifyGoodsName',
          headerAlign: 'center',
          align: 'left',
          minWidth: 300,
          showHeaderOverflow: true,
        },
        {
          title: '订单数量',
          field: 'orderQty',
          headerAlign: 'center',
          align: 'center',
          width: 90,
          showHeaderOverflow: true,
        },
        {
          title: '裁剪尺寸',
          field: 'cuttingSizeDesc',
          headerAlign: 'center',
          align: 'center',
          width: 120,
          showHeaderOverflow: true,
        },
        {
          title: '裁片门幅',
          field: 'cuttingWidth',
          headerAlign: 'center',
          align: 'center',
          width: 90,
          showHeaderOverflow: true,
        },
        {
          title: '裁片损耗',
          field: 'cuttingLoss',
          headerAlign: 'center',
          align: 'center',
          width: 90,
          showHeaderOverflow: true,
        },
        {
          title: '单耗',
          field: 'unitQty',
          headerAlign: 'center',
          align: 'center',
          width: 90,
          showHeaderOverflow: true,
        },
        // {
        //   title: '耗料',
        //   field: 'fabricQty',
        //   headerAlign: 'center',
        //   align: 'left',
        //   minWidth: 150,
        //   showHeaderOverflow: true,
        //   showOverflow: true
        // },
        {
          title: '裁片数量',
          field: 'cuttingQty',
          headerAlign: 'center',
          align: 'center',
          width: 90,
          showHeaderOverflow: true,
        },
        {
          title: '合计耗料',
          field: 'subQty',
          headerAlign: 'center',
          align: 'right',
          width: 100,
          showHeaderOverflow: true,
        },
        {
          title: '备注说明',
          field: 'cuttingRemark',
          headerAlign: 'center',
          align: 'left',
          minWidth: 300,
          showHeaderOverflow: true,
        },
        // {
        //   title: this.$l('INDEX.table_label_modified_by') || '修改人',
        //   field: 'modifyByName',
        //   minWidth: 170,
        //   headerAlign: 'center',
        //   align: 'center',
        //   showHeaderOverflow: true
        // },
        // {
        //   title: '修改时间',
        //   field: 'modifyTime',
        //   minWidth: 170,
        //   headerAlign: 'center',
        //   align: 'center',
        //   showHeaderOverflow: true
        // }
      ],
    }
  },
  methods: {
    del(code) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '确认要删除该记录吗？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .techCuttingInfoGoodsDelApi({ techCuttingGoodsCode: code })
          .then((res) => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || res.msg,
              type: 'success',
            })
            this.$emit('reload')
          })
      })
    },
  },
}
</script>
